import { get, writable } from 'svelte/store';
import { WeightLabelService } from '../../services/weight-label.service';
import { ReportService } from '../../services/report-service';
import { formatDateOnlyISO } from '../../utils/date-utils';
export const loading = writable(false);
export const filter = writable({ criteria: { refDate: formatDateOnlyISO(new Date()), showAll: 0 } });
export const records = writable([]);
export const pagination = writable(null);
export const printRange = writable({ slaughterDate: "", minValue: 0, maxValue: 0 });
export async function initList() {
    let refDate = formatDateOnlyISO(new Date());
    filter.set({ criteria: { refDate: refDate, showAll: 0 }, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await WeightLabelService.getWeightLabelItems(_filter, _pag.currentPage);
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onPageChange(event) {
    let pageNumber = event.detail;
    // console.log("onPageChange: " + pageNumber);
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
export function onDateFilterChanged(evt) {
    let date = evt.detail;
    if (!date)
        return;
    let _filter = get(filter);
    filter.set(Object.assign(Object.assign({}, _filter), { criteria: Object.assign(Object.assign({}, _filter.criteria), { refDate: date }) }));
    search();
}
export async function saveManualWeight(item, weight) {
    let dto = {
        slaughterWeightId: item.slaughterWeight.oid,
        weight: weight
    };
    await WeightLabelService.saveManualWeight(dto);
    await load();
}
export async function printLabelsRange() {
    let _filter = get(filter);
    let _printRange = get(printRange);
    let dto = { slaughterDate: _filter.criteria.refDate, minValue: _printRange.minValue, maxValue: _printRange.maxValue };
    printRange.set({ slaughterDate: "", minValue: 0, maxValue: 0 });
    await WeightLabelService.printLabelsRange(dto);
    await load();
}
// now it's in slaughter list
// export async function downloadDailySlaughterReport() {
//   let criteria: IReportSearchDailySlaughterDTO = { slaughterDate: get(filter).criteria.refDate };
//   let dto: ISearchFilterDTO<IReportSearchDailySlaughterDTO> = { criteria: criteria, params: null, sorting: "" };
//   ReportService.exportPdfDailySlaughter(dto);
// }
